import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";

const ChatMessage = ({ message }) => {
  const isFromMe = message.from === "me";

  return (
    <div className={`bubble ${isFromMe ? "from-me" : "from-them"}`}>
      <div>{message.text}</div>
      {message.files && message.files.length > 0 && (
        <div className="files">
          {message.files.map((file, idx) => (
            <a 
              key={idx} 
              href={file} 
              target="_blank" 
              rel="noopener noreferrer" 
              download 
              style={{ textDecoration: "none" }}
            >
              <span className="filechip">
                📎 {file.split("/").pop()} <FontAwesomeIcon icon={faDownload} />
              </span>
            </a>
          ))}
        </div>
      )}
      <div className="meta">
        {isFromMe ? "You" : message.user?.name || "Contact"} • {message.ts}{" "}
        {isFromMe && (
          <span title={
            message.status === "read" ? "Read" : 
            message.status === "delivered" ? "Delivered" : 
            "Sent"
          }>
            {message.status === "read" ? "✓✓" : 
             message.status === "delivered" ? "✓✓" : 
             "✓"}
          </span>
        )}
      </div>
    </div>
  );
};

ChatMessage.propTypes = {
  message: PropTypes.shape({
    from: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    ts: PropTypes.string.isRequired,
    files: PropTypes.array,
    status: PropTypes.string,
    user: PropTypes.object,
  }).isRequired,
};

export default ChatMessage;

